import { render, staticRenderFns } from "./AppDateField.vue?vue&type=template&id=6f4cf487&scoped=true&"
import script from "./AppDateField.vue?vue&type=script&lang=js&"
export * from "./AppDateField.vue?vue&type=script&lang=js&"
import style0 from "./AppDateField.vue?vue&type=style&index=0&id=6f4cf487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4cf487",
  null
  
)

export default component.exports